// src/components/menus/LeftMenu.jsx
import { useContext, useEffect, useState } from "react";
import {
  Select,
  MenuItem,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import { useAuth } from "../../context/AuthContext";
import { LanguageContext } from "../../context/LanguageContext";
import SmartToyIcon from "@mui/icons-material/SmartToy";

// Icons
import DashboardIcon from "@mui/icons-material/Dashboard";
import AndroidIcon from "@mui/icons-material/Android";
import HubIcon from "@mui/icons-material/Hub";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

import USFlag from "../../images/flags/uk-flag-icon.png";
import FranceFlag from "../../images/flags/french-flag-icon.png";
import TalkmateLogo from "../../images/talk_mate_horizontal.png";

export default function LeftMenu() {
  const theme = useTheme();
  const { translate, language, setLanguage } = useContext(LanguageContext);
  const { currentUser } = useAuth();
  const [userRole, setUserRole] = useState();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!currentUser) return;
    const unsub = onSnapshot(
      doc(db, "profilsUsers", currentUser.uid),
      (snap) => {
        if (snap.exists()) setUserRole(snap.data().role);
      }
    );
    return unsub;
  }, [currentUser]);

  const menuItems = [
    { label: translate("Agents"), icon: <SmartToyIcon />, path: "/app/agents" },

    {
      label: translate("Dashboard"),
      icon: <DashboardIcon />,
      path: "/app/dashboard",
    },
    // {
    //   label: translate("Integrations"),
    //   icon: <HubIcon />,
    //   path: "/app/integrations",
    // },
    // {
    //   label: translate("Analytics"),
    //   icon: <QueryStatsIcon />,
    //   path: "/app/analytics",
    // },
    // {
    //   label: translate("Billing"),
    //   icon: <CreditScoreIcon />,
    //   path: "/app/billing",
    // },
    {
      label: translate("HelpFAQs"),
      icon: <HelpOutlineIcon />,
      path: "/app/help",
    },
  ];

  if (userRole === "SuperAdmin") {
    menuItems.push({
      label: "Super Admin",
      icon: <ManageAccountsIcon />,
      path: "/app/superadmin/users",
    });
  }

  console.log("language:", language);

  return (
    <div
      style={{
        width: 220,
        minWidth: 200,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        height: "100vh",
        maxHeight: "100vh",
        padding: "20px 10px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRight: `1px solid ${theme.palette.divider}`,
        position: "sticky",
        top: 0,
        overflowY: "auto",
        overscrollBehavior: "contain",
      }}
    >
      {/* Logo */}
      <div>
        <div style={{ paddingLeft: "15px", paddingTop: "10px" }}>
          <img src={TalkmateLogo} alt="Logo" style={{ width: 130 }} />
        </div>

        {/* Menu */}
        <List disablePadding sx={{ mt: 3 }}>
          {menuItems.map((item) => (
            <ListItemButton
              key={item.path}
              selected={location.pathname === item.path}
              onClick={() => navigate(item.path)}
              sx={{
                borderRadius: 1,
                mb: 0.5,
                display: "flex",
                alignItems: "center",
                gap: "10px",
                color: theme.palette.text.primary,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: 0,
                  justifyContent: "center",
                  color: "inherit",
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "inherit",
                }}
              />
            </ListItemButton>
          ))}
        </List>
      </div>

      {/* Langue */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          displayEmpty
          IconComponent={() => null}
          sx={{
            height: 30,
            minWidth: 70,
            pl: 1,
            bgcolor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              gap: 1,
              p: 0,
            },
          }}
        >
          <MenuItem
            value="en"
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <img src={USFlag} alt="" width={20} /> English
          </MenuItem>
          <MenuItem
            value="fr"
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <img src={FranceFlag} alt="" width={20} /> Français
          </MenuItem>
        </Select>
      </div>
    </div>
  );
}
